import * as z from "zod"
import { BacklogStatus } from "@prisma/client"

export const BacklogModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  provider_id: z.string(),
  airport_id: z.string(),
  starts_at: z.date(),
  next_flight_at: z.date().nullish(),
  expires_at: z.date().nullish(),
  status: z.nativeEnum(BacklogStatus),
  note: z.string().nullish(),
})
